import axios from 'axios';

// Creates a "clean" instance of axios minus our user defaults
// eslint-disable-next-line import/prefer-default-export
export function defaultInstance(config) {
  const axiosInstance = axios.create({ withCredentials: false, ...config });

  delete axiosInstance.defaults.baseURL;
  delete axiosInstance.defaults.headers.common.Authorization;
  delete axiosInstance.defaults.headers.Expires;

  return axiosInstance;
}
